import { Toast } from 'buefy'
const inform = (message, type = 'is-success') => {
  return Toast.open({
    position: 'is-top-right',
    message,
    type
  })
}
export default inform



// WEBPACK FOOTER //
// ./src/services/inform.js